function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0503 3L10.6803 5.60648C9.70138 7.46857 8.20934 9.32036 6.62033 10.7729C5.59979 11.6952 5.01669 12.9584 5.00033 14.2823V14.4499C4.9733 17.0425 6.60169 19.2435 9.20033 20.3983C11.1742 21.2754 12.7785 21.3491 14.7903 20.5007C17.4455 19.3809 19 16.5 19 14C19 12 18.5 11 18.5 11C18.5 11 16.5729 13.7002 14.6103 14.5151C12.6477 15.3299 11.2546 15.162 13.5503 13.5376C15.8461 11.9132 16.3813 8.90342 14.7703 6.677C13.4703 4.83385 12.0503 3 12.0503 3Z",
  stroke: "#A4A5A8",
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.036 7L11.0574 9.01626C10.3581 10.4567 9.29238 11.8892 8.15738 13.0128C7.42842 13.7262 7.01192 14.7034 7.00024 15.7275V15.8571C6.98093 17.8627 8.14406 19.5652 10.0002 20.4585C11.4101 21.1371 12.5561 21.194 13.9931 20.5377C15.8897 19.6716 17 17.443 17 15.5091C17 13.962 16.6429 13.1885 16.6429 13.1885C16.6429 13.1885 15.9019 13.8697 14.5 14.5C13.0981 15.1303 11.3926 15.3485 13 14C14.6074 12.6515 15.1295 11.5666 13.9788 9.84437C13.0502 8.41858 12.036 7 12.036 7Z",
  stroke: "#A4A5A8",
  strokeLinecap: "round"
});

function SvgNitronLiquidations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitronLiquidations);
export default __webpack_public_path__ + "static/media/NitronLiquidations.1ba510ecda9c926f2b49aa15eb29984d.svg";
export { ForwardRef as ReactComponent };